<template>
  <div class="fullscreen bg-primary text-white text-center q-pa-md flex flex-center">
    <div>
      <div v-if="status" style="font-size: 30vh">
        {{ status }}
      </div>
      <div v-else style="font-size: 30vh">404</div>

      <div v-if="error" class="text-h2" style="opacity: 0.4">
        {{ error }}
      </div>
      <div v-else class="text-h2" style="opacity: 0.4">Oops. Nothing here...</div>

      <q-btn
        class="q-mt-xl"
        color="white"
        text-color="primary"
        unelevated
        :to="{ name: 'Home' }"
        label="Go Home"
        no-caps
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeRouteLeave } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useErrorStore } from 'stores/error-store'

const errorStore = useErrorStore()

const { error, status } = storeToRefs(errorStore)

onBeforeRouteLeave(() => {
  errorStore.$reset()
})
</script>
